import axios from '@/_services/axios';

export function GetAll() {
  return new Promise((resolve, reject) => {
    axios
      .get('units/all')
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}
